import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import {SalaryRejectionButtonContainer, SalaryRejectionContainer} from "./styles";
import {isValidString} from "../../../../utils";
import {useDispatch} from "react-redux";
import {Employee} from "../../../../app/interfaces";
import {Modal, PrimaryButton, TextArea} from '../../../../components';
import {rejectSalaryUpdate} from "../../../../app/employee/actions";

interface SalaryRejectionModalProps {
    employee: Employee,
    isOpen: boolean,
    onClose: () => void
}
export const SalaryRejectionModal = ({employee, isOpen, onClose}: SalaryRejectionModalProps) => {

    const [rejectReason, setRejectReason] = useState<string>('')
    const {t} = useTranslation()
    const dispatch = useDispatch()


    const handleTextInput = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setRejectReason(event.target.value);
    }

    const handleSubmit = () => {
            dispatch(rejectSalaryUpdate({
                employeeId: employee._id,
                companyId: employee.company._id,
                reason: rejectReason
            }) as any)
    }

    return <Modal isOpen={isOpen} onClickOutside={onClose}>
        <SalaryRejectionContainer>
            <h1>{t('explain_salary_rejection_title')}</h1>
            <p>{t('explain_salary_rejection_message')}</p>
            <TextArea
                value={rejectReason}
                label={t('details') as string}
                onChange={handleTextInput}
                status={isValidString(rejectReason) ? 'normal' : 'danger'}
                helperText={isValidString(rejectReason) ? '' : t('enter_a_valid_description') as string}
            />
            <SalaryRejectionButtonContainer>
                <PrimaryButton
                    disabled={!isValidString(rejectReason)}
                    onClick={handleSubmit}
                >
                    {t('submit')}
                </PrimaryButton>
            </SalaryRejectionButtonContainer>
        </SalaryRejectionContainer>
    </Modal>
}
